import React, { useEffect, useRef, useState } from "react";
import InnerBanner from "../components/InnerBanner";
import AboutSection from "../components/AboutSection";
import AboutFeature from "../components/AboutFeature";
import Header from "../components/Header";
import { dashboard } from "../handler/LoginAndSingupHandler";

const ContactPage: React.FC = () => {
  const [statistics, setStatistics] = useState({
    students: 0,
    courses: 0,
    teachers: 0,
    awards: 0,
  });

  const runOnce = useRef(false);

  const dashboardApi = async () => {
    try {
      const response = await dashboard();

      if (response.statusCode === 200) {
        setStatistics(response.data.dashboard.statistics);
      }
    } catch (error) {
      console.error("Dashboard API error:", error);
    }
  };

  useEffect(() => {
    if (!runOnce.current) {
      dashboardApi();
      runOnce.current = true;
    }
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#000000",
        color: "#ffffff",
        overflow: "hidden",
      }}
    >
      {/* =====================================================
          HEADER
      ====================================================== */}

      <Header />

      {/* =====================================================
          INNER BANNER
      ====================================================== */}

      <InnerBanner pageName="About Us" />

      {/* =====================================================
          ABOUT / STATISTICS
      ====================================================== */}

      <section
        style={{
          background:
            "linear-gradient(180deg, #020303 0%, #05070b 100%)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Background grid */}

        <div
          style={{
            position: "absolute",
            inset: 0,
            pointerEvents: "none",
            opacity: 0.06,
            backgroundImage:
              "linear-gradient(rgba(255,255,255,0.08) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.08) 1px, transparent 1px)",
            backgroundSize: "32px 32px",
          }}
        />

        {/* Cyan glow */}

        <div
          style={{
            position: "absolute",
            width: "300px",
            height: "300px",
            left: "-150px",
            top: "50px",
            borderRadius: "50%",
            background: "rgba(0,246,255,0.06)",
            filter: "blur(100px)",
            pointerEvents: "none",
          }}
        />

        {/* Purple glow */}

        <div
          style={{
            position: "absolute",
            width: "300px",
            height: "300px",
            right: "-150px",
            bottom: "50px",
            borderRadius: "50%",
            background: "rgba(139,92,255,0.06)",
            filter: "blur(100px)",
            pointerEvents: "none",
          }}
        />

        <div
          style={{
            position: "relative",
            zIndex: 2,
          }}
        >
          <AboutSection
            statistics={{
              students: statistics.students + 1000,
              courses: statistics.courses,
              teachers: statistics.teachers,
              awards: statistics.awards,
            }}
          />
        </div>
      </section>

      {/* =====================================================
          ABOUT FEATURE
      ====================================================== */}

      <section
        style={{
          position: "relative",
          background: "#000000",
          overflow: "hidden",
          borderTop:
            "1px solid rgba(0,246,255,0.08)",
        }}
      >
        {/* Grid */}

        <div
          style={{
            position: "absolute",
            inset: 0,
            pointerEvents: "none",
            opacity: 0.045,
            backgroundImage:
              "linear-gradient(rgba(255,255,255,0.08) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.08) 1px, transparent 1px)",
            backgroundSize: "32px 32px",
          }}
        />

        <div
          style={{
            position: "relative",
            zIndex: 2,
          }}
        >
          <AboutFeature />
        </div>
      </section>
    </div>
  );
};

export default ContactPage;